import { SESClient, SendEmailCommand } from "@aws-sdk/client-ses";
import { supabase } from '../supabaseClient';
import { emailService } from '../services/emailService';

// Configure AWS SES
const sesClient = new SESClient({
  credentials: {
    accessKeyId: import.meta.env.VITE_AWS_ACCESS_KEY_ID,
    secretAccessKey: import.meta.env.VITE_AWS_SECRET_ACCESS_KEY,
  },
  region: import.meta.env.VITE_AWS_REGION || 'us-east-1'
});

export const sendEmailSES = async ({ to, subject, html, text }) => {
  const params = {
    Destination: {
      ToAddresses: Array.isArray(to) ? to : [to]
    },
    Message: {
      Body: {
        Html: {
          Charset: 'UTF-8',
          Data: html
        },
        Text: {
          Charset: 'UTF-8',
          Data: text
        }
      },
      Subject: {
        Charset: 'UTF-8',
        Data: subject
      }
    },
    Source: import.meta.env.VITE_AWS_SES_FROM_EMAIL
  };

  try {
    const command = new SendEmailCommand(params);
    const result = await sesClient.send(command);
    return { success: true, messageId: result.MessageId };
  } catch (error) {
    console.error('SES error:', error);
    throw new Error(`Failed to send email: ${error.message}`);
  }
};

// Helper function to replace template variables
export const replaceTemplateVariables = (content, variables) => {
  return emailService.replaceVariables(content, variables);
};

// Function to send an email using a template
export const sendTemplateEmail = async (templateName, recipientEmail, variables) => {
  let template;
  try {
    // Fetch template from database
    const { data: templates, error: templateError } = await supabase
      .from('email_templates')
      .select('*')
      .eq('name', templateName)
      .single();

    if (templateError) throw templateError;
    if (!templates) throw new Error(`Template ${templateName} not found`);

    template = templates;

    // Replace variables in template
    const html = replaceTemplateVariables(template.html_content, variables);
    const text = replaceTemplateVariables(template.text_content, variables);

    // Send email
    const result = await sendEmailSES({
      to: recipientEmail,
      subject: template.subject,
      html,
      text
    });

    // Log the email
    const { error: logError } = await supabase.from('email_logs').insert({
      template_id: template.id,
      message_id: result.messageId,
      subject: template.subject,
      sender: import.meta.env.VITE_SES_FROM_EMAIL || 'no-reply@example.com',
      recipients: [recipientEmail],
      content_html: html,
      content_text: text,
      recipient_email: recipientEmail,
      recipient_name: variables.memberName,
      status: 'sent',
      sent_at: new Date().toISOString(),
      aws_response: result
    });

    if (logError) {
      console.error('Failed to log email:', logError);
    }

    return result;
  } catch (error) {
    // Log the error
    if (template) {
      const { error: logError } = await supabase.from('email_logs').insert({
        template_id: template.id,
        subject: template.subject,
        sender: import.meta.env.VITE_SES_FROM_EMAIL || 'no-reply@example.com',
        recipients: [recipientEmail],
        recipient_email: recipientEmail,
        recipient_name: variables.memberName,
        status: 'failed',
        error_message: error.message,
        sent_at: new Date().toISOString()
      });

      if (logError) {
        console.error('Failed to log email error:', logError);
      }
    }
    throw error;
  }
};
